import React from 'react';
import CompanyProfileForm from '../components/settings/CompanyProfileForm';

const Settings = () => {
  return (
    <div className="container mt-4">
      <h2><b>Company Profile</b></h2>
      <br></br>
      <hr />
      <CompanyProfileForm />
    </div>
  );
};

export default Settings;
